module.exports = __webpack_public_path__ + "static/img/zgnjjbhyqh.6e3c05eb.png";